import route from 'route';

const mainRoute = route.DASHBOARD;
const goldRoute = `${mainRoute}/gold`;

export default {
  TRANSACTION_LOG: `${goldRoute}/transaction-log`,
  TRANSACTION_DETAIL: `${goldRoute}/transaction-log/:id`,
};
